import React from 'react'
import Perfil from "../assets/static/perfil.jpeg";
import '../assets/css/NewAbout.css'
import useNearScreen from '../hooks/useNearScreen';

export default function NewAbout() {

    const { isNearScreen, fromRef } = useNearScreen({distance: '-30px'})

  return (
    <div className='NewAbout'>
        <div className="NewAbout-Container">
        <div className="NewAbout-Text">
            <h2 ref={fromRef} className={ isNearScreen ? "NewAbout-Text-h2" : 'NewAbout-Text-h2-dis'}>About Me</h2>
            <p className={isNearScreen ? "NewAbout-Text-p" : "NewAbout-Text-p-dis"}>
              Hi, I'm Nahuel and I'm going to tell you how my passion for
              programming was born. Since I was a child I have loved Star Wars,
              Vader, Yoda, Luke, C3PO, R2-D2... robots. In 2012 I
              started my university studies in Robotics, an important branch is
              programming. In 2016 I graduated as a Higher Technician in
              Automation and Robotics, then in 2019 with a degree in Management
              of Automation and Robotics Systems. During those years what I
              liked the most was programming, and in 2021 I found Web
              Development and fell in love with it.
            </p>
          </div>
          <div className="NewAbout-ContImg">
            <img className={isNearScreen ? 'NewAbout-ContImg-Img' : 'NewAbout-ContImg-Img-dis' } src={Perfil} alt="" />
          </div>
        </div>
    </div>
  )
}
